// import {API_URL} from "@/providers/config";

const API_URL = process.env.VUE_APP_API_URL;

export function getFiles (value: any){
    return value ? [value] : [];
}

export function getServer (empleado: any){
    return {
        url: API_URL + 'empleados/files/' + empleado?.id_empleado
    };
}